import React, { useContext } from "react";
import { BsInstagram, BsGithub, BsLinkedin, BsWhatsapp } from "react-icons/bs";
import "./footer.css";
import { ModeContext } from "../utils/modes-context";

const Footer = () => {
  const { darkMode } = useContext(ModeContext);
  return (
    <section
      className={darkMode ? "footer" : "footer footer_lightmode"}
      id="footer">
      <div className="media_icons">
        <a
          href="https://github.com/Krishna698-web/"
          target="_blank"
          rel="noreferrer">
          <BsGithub className="media_icon" />
        </a>
        <a
          href="https://www.instagram.com/krishnamk111/"
          target="_blank"
          rel="noreferrer">
          <BsInstagram className="media_icon" />
        </a>
        <a
          href="https://www.linkedin.com/in/krishna-m-k/"
          target="_blank"
          rel="noreferrer">
          <BsLinkedin className="media_icon" />
        </a>
        <a href="https://wa.me/+917022204986" target="_blank" rel="noreferrer">
          <BsWhatsapp className="media_icon" />
        </a>
      </div>
      <a href="#home">Thank you for visiting</a>
    </section>
  );
};

export default Footer;
